import { CLEAR_REPORT_PASSWORDS, SET_REPORT_PASSWORD } from './ActionTypes';

export const setReportPassword = (key: string, password: string) => ({
  type: SET_REPORT_PASSWORD,
  payload: { key, password, timestamp: Date.now() },
});

export const clearReportPasswords = () => ({
  type: CLEAR_REPORT_PASSWORDS,
});
